import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDAsMhlSjDt292Khj8OWXCaOGJLj_2rdZg",
  authDomain: "trillionstock-e9b0f.firebaseapp.com",
  projectId: "trillionstock-e9b0f",
  storageBucket: "trillionstock-e9b0f.firebasestorage.app",
  messagingSenderId: "440078664837",
  appId: "1:440078664837:web:49eb1571fb42eb562915ec",
  measurementId: "G-P9J6YRVKMP"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(app);

// Initialize Firestore
export const db = getFirestore(app);

// Initialize Google Auth Provider
export const googleProvider = new GoogleAuthProvider();
googleProvider.setCustomParameters({
  prompt: 'select_account'
});

export default app;
